import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { Field } from 'react-final-form';
import { Button } from 'antd';
import Translate from 'react-translate-component';
import { equals, path } from 'ramda';
import moment from 'moment';
import * as yup from 'yup';

import { updateEvent } from 'actions/asyncActions';
import RadioButtons from 'components/common/form/RadioButtons';
import Select from 'components/common/form/Select';
import Text from 'components/common/form/Text';
import DatePicker from 'components/common/form/DatePicker';
import { WORKING_PROBATION_DICT, WORKING_PASSED_CODE } from 'constants/events';
import { DATE_FORMATS } from 'constants/dateFormats';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { required } from 'utils/validators';
import ListenerField from 'components/common/form/ListenerField';

const isWorkingPassed = equals(WORKING_PASSED_CODE);

const validationSchema = yup.object().shape({
    details: yup.object().shape({
        eventResult: yup.string().required(),
        endDate: yup.string().dateIsNowOrBefore().nullable().required()
    })
});

@asyncConnect({
    formAction: updateEvent
        .withSuccessHandler(({ closeModal }) => closeModal())
        .withOptions({ autoReset: true })
})
@withFormWrapper({
    mapPropsToValues: ({ event }) => ({
        id: event.id,
        details: {
            endDate: moment().format(DATE_FORMATS.format),
        }
    }),
    validationSchema
})
export default class EventProbationForm extends Component {
    static propTypes = {
        formAction: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
        close: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        form: PropTypes.object,
        handleSubmit: PropTypes.func
    }

    checkEventResult = values => {
        const eventResult = path(['details', 'eventResult'], values);
        const isPassed = isWorkingPassed(eventResult);
        const isHidden =  eventResult ? isPassed : true;

        return {
            eventResult,
            isPassed,
            isHidden
        };
    }

    onChangeEventResult = () => {
        this.props.form.change('details.personState', null);
        this.props.form.change('details.resultComment', null);
    }

    validateReject = (value, values) => {
        const { isHidden } = this.checkEventResult(values);
        return !isHidden ? required(value) : undefined;
    }

    renderEventResult = (values) => {
        const { event } = this.props;
        const { eventResult, isHidden, isPassed } = this.checkEventResult(values);

        return (
            <Fragment>
                <Field
                    name='details.personState'
                    component={Select}
                    options={event.excludeReasons}
                    namePath='text'
                    hidden={isHidden}
                    label={{ content: 'events.reason', required: true }}
                    validate={this.validateReject}
                />
                <Field
                    name='details.resultComment'
                    component={Text}
                    hidden={isHidden}
                    label={{ content: 'events.comment', required: true }}
                    validate={this.validateReject}
                />
                <Field
                    name='details.endDate'
                    component={DatePicker}
                    allowClear={false}
                    hidden={!eventResult}
                    label={{
                        content: isPassed ? 'events.endOfProbation' : 'events.dateDismiss',
                        required: true
                    }}
                />
            </Fragment>
        );
    }

    render() {
        const { handleSubmit, close }  = this.props;

        return (
            <div className='panel-view probation-form'>
                <Field
                    name='details.eventResult'
                    component={RadioButtons}
                    radioTranslate='events'
                    options={WORKING_PROBATION_DICT}
                    label={{ content: 'events.result', required: true }}
                    onChange={this.onChangeEventResult}
                />
                <ListenerField
                    listenFieldName='details.eventResult'
                >
                    { this.renderEventResult }
                </ListenerField>
                <Button className='card-button close-button event-result-probation-cancel' onClick={close}>
                    <Translate content='events.cancel' />
                </Button>
                <Button onClick={handleSubmit} type='primary'>
                    <Translate content='events.saveEventResult' />
                </Button>
            </div>
        );
    }
}
